<template>
  <div>
    <modal
      :show.sync="editEmbed"
      scrollable
      header-classes="bg-primary p-2 flex items-center"
      footerClasses=""
      size="lg"
      bodyClasses=""
      @close="closeModal"
    >
      <h6 slot="header" class="modal-title text-white pl-4 font-semibold">
        Edit Embedded
      </h6>
      <div>
        <base-input
          v-model="url_data.name"
          placeholder="Enter name"
          class="cust-mb0"
          :rules="{ required: true }"
          name="name"
        ></base-input>
        <base-input
          v-model="url_data.url"
          placeholder="Enter URL"
          class="cust-mb0"
          :rules="{ required: true }"
          name="embedded"
        ></base-input>

        <!-- <b-button type="primary"
          >Create Chapter</b-button -->
      </div>
      <template slot="footer">
        <base-button type="primary" @click.once="handleEdit()"
          >EDIT EMBEDDED</base-button
        >
        <base-button type="secondary" class="ml-auto" @click="closeModal"
          >CLOSE</base-button
        >
      </template>
    </modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url_data: {},
    };
  },
  props: {
    editEmbed: Boolean,
    urlData: Object,
    chapter: Object,
  },
  watch: {
    urlData(newVal) {
      this.url_data = { ...newVal };
    },
  },

  methods: {
    closeModal() {
      this.$emit("close-editEmbed");
    },

    async handleEdit() {
      let loader = this.$loading();
      try {
        const data = await this.$store.dispatch("eLearning/editEmbedded", {
          _id: this.url_data._id,
          url: this.url_data.url,
          name: this.url_data.name,
        });
        if (data.code == 200) {
          loader.close();
          await this.$store.dispatch("eLearning/getChapterByCourseId", {
            id: this.chapter.course[0],
          });
          this.$swal.fire({
            title: "Edited",

            text: "Edited Successfully!",

            icon: "success",
            showConfirmButton: false,
            showCancelButton: false,
            timer: 2000,
          });
          this.closeModal();
        }
      } catch (err) {
        loader.close();
      }
    },
  },
};
</script>
